import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import {
  MembersViewProvider,
  useMembersViewContext,
} from 'pages/settings/pages/members/pages/membersView/context/membersViewContext'
import { MembersViewContent } from 'pages/settings/pages/members/pages/membersView/MembersView'

const MembersListLayoutInner = observer(() => {
  const { fetchCounts } = useMembersViewContext()
  const { pathname } = useLocation()

  useEffect(() => {
    fetchCounts()
  }, [pathname])

  return <MembersViewContent />
})

export const MembersListLayout = () => {
  return (
    <MembersViewProvider>
      <MembersListLayoutInner />
    </MembersViewProvider>
  )
}
